class ListsContent {
    constructor() {
        this.classes = {
            single: ['col-md-12', 'col-lg-12', 'card-single'],
            gridSingle: ['col-md-12', 'col-lg-12'],
            double: ['col-md-6', 'col-lg-6'],
            cardDouble: ['col-md-6', 'col-lg-6', 'card-double'],
            multi: ['col-md-6', 'col-lg-4']
        };
    }

    styleLists() {
        const cardWrapper = document.querySelectorAll('.js-card-lift.automatic');
        for (let i = 0; i < cardWrapper.length; i++) {
            let visibleElements = [...cardWrapper[i].children].filter(n => !n.classList.contains('do-not-show') && !n.classList.contains('grid-card-lift') && n.classList.contains('card-lift'));
            this.addCssClasses(visibleElements);
        }
    }

    styleGridLists() {
        const cardGridWrapper = document.querySelectorAll('.js-card-lift-grid .js-card-lift');
        for (let i = 0; i < cardGridWrapper.length; i++) {
            let visibleGridElements = [...cardGridWrapper[i].children].filter(n => !n.classList.contains('do-not-show') && n.classList.contains('card-lift'));
            visibleGridElements.forEach(el => {
                 el.classList.remove('card-lift');
                 el.classList.add('grid-card-lift'); 
            });  
            
            switch(visibleGridElements.length) {
                case 1:
                this.changeLayout(visibleGridElements, this.classes.gridSingle);
                break;
                case 2:
                this.changeLayout(visibleGridElements, this.classes.double);
                break;
                default:
                this.changeLayout(visibleGridElements, this.classes.multi);
            }
        }
    }

    styleSingleLists() {
        const cardWrapper = document.querySelectorAll('.js-card-lift.list-view');
        for (let i = 0; i < cardWrapper.length; i++) {
            let visibleElements = [...cardWrapper[i].children].filter(n => !n.classList.contains('do-not-show') && !n.classList.contains('grid-card-lift') && n.classList.contains('card-lift'));
            
            switch(visibleElements.length) {
                case 1:
                    this.changeLayout(visibleElements.slice(0, 1), this.classes.gridSingle);
                    break;
                case 2:
                    this.changeLayout(visibleElements.slice(0, 2), this.classes.double);
                    break;
                default:
                    this.changeLayout(visibleElements.slice(), this.classes.multi);
            }
        }
    }

    addCssClasses(visibleElements) {
        switch(visibleElements.length % 3) {
            case 1:
                this.changeLayout(visibleElements.slice(0, 1), this.classes.single);
                this.changeLayout(visibleElements.slice(1), this.classes.multi);
                break;
            case 2:
                this.changeLayout(visibleElements.slice(0, 2), this.classes.cardDouble);
                this.changeLayout(visibleElements.slice(2), this.classes.multi);
                break;
            default:
                this.changeLayout(visibleElements.slice(), this.classes.multi);
        }
    }

    changeLayout(items, classes) {
        if(items && items.length > 0) {
            items.forEach(el => {
                if(el.nodeType === Node.ELEMENT_NODE ) {
                 el.classList.remove(...this.classes.single, ...this.classes.double, ...this.classes.multi, ...this.classes.cardDouble);
                 el.classList.add(...classes);
                } else{
                    el.className = classes.reduce((cur, next) => cur + ' ' + next);
                }
            });
        }
    }
 }

export default ListsContent;
